/** Per-device record of which notes get opened, for Home's "Suggested" tabs. */
const KEY = "engram.opens";
type Opens = Record<string, { n: number; last: number }>;

function read(): Opens {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Opens;
  } catch {
    return {};
  }
}

export function recordOpen(id: string) {
  try {
    const o = read();
    const e = o[id] ?? { n: 0, last: 0 };
    o[id] = { n: e.n + 1, last: Date.now() };
    // Keep the 300 most recent entries.
    const entries = Object.entries(o).sort((a, b) => b[1].last - a[1].last).slice(0, 300);
    localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(entries)));
  } catch {
    /* storage unavailable */
  }
}

/** Note ids opened most recently, newest first. */
export function recentNoteIds(limit = 8): string[] {
  return Object.entries(read())
    .sort((a, b) => b[1].last - a[1].last)
    .slice(0, limit)
    .map(([id]) => id);
}

/** How often each note was opened on this device in the last `days` days ({ id: count }). */
export function openCounts(days: number): Record<string, number> {
  const cutoff = Date.now() - days * 86400000;
  return Object.fromEntries(Object.entries(read()).filter(([, e]) => e.last > cutoff).map(([id, e]) => [id, e.n]));
}

/** Note ids opened most often in the last 60 days, best first. */
export function suggestedNoteIds(limit = 12): string[] {
  const cutoff = Date.now() - 60 * 86400000;
  return Object.entries(read())
    .filter(([, e]) => e.last > cutoff && e.n > 1)
    .sort((a, b) => b[1].n - a[1].n)
    .slice(0, limit)
    .map(([id]) => id);
}
